let xmlString = "";

// export function xlmgenerator_old(item, doctype, state) {
// 	console.log("XML generator", item, "\n", doctype, "state", state)
// 	xmlString = xmlString + "<S2MParms>\n<Contact2Email>S2MServerV2@StateAuto.com</Contact2Email>\n<IncEmailMsg>No</IncEmailMsg>\n"
// 	// xmlString = xmlString + "<S2MParms>\n<Contact2Email>S2MServerV2@StateAuto.com</Contact2Email>\n"
// 	xmlString = xmlString + "<EM-From>" + item.from.displayName + "</EM-From>\n"
// 	xmlString = xmlString + "<EM-CC>" + item.cc + "</EM-CC>\n"
// 	xmlString = xmlString + "<EM-Date>" + item.dateTimeCreated + "</EM-Date>\n"
// 	xmlString = xmlString + "<EM-Subject>" + item.subject + "</EM-Subject>\n"
// 	xmlString = xmlString + "<PDFDestination>Mobius</PDFDestination>\n"

// 	if (doctype === "Policy") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL_P" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "POLICY_DOC" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.policysymbol + " " + state.policynumber + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.policysymbol + " " + state.policynumber + " " + state.description + "</Section>\n"
// 	}
// 	if (doctype === "Agency") {
// 		xmlString = xmlString + "<Report-ID>" + "A.EMAIL.A" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "AGENCYFILE" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.agencynumber + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (doctype === "Beacon_System") {
// 		xmlString = xmlString + "<Report-ID>" + "LET.BEACON" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "POL_BEACON" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.beaconsystempolicynumber + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.beaconsystempolicynumber + " " + state.description + "</Section>\n"
// 	}
// 	if (doctype === "Bonds") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.BOND" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "POLICY_DOC" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.bondspolicynumber + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.bondspolicynumber + " " + state.description + "</Section>\n"
// 	}
// 	if (doctype === "Claim") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL_C" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "CLAIM_DOC" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.claimsymbol + " " + state.claimnumber + " " + state.claimdol + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.claimsymbol + " " + state.claimnumber + " " + state.description + "</Section>\n"
// 	}
// 	if (doctype === "Owned_Prop") {
// 		xmlString = xmlString + "<Report-ID>" + "OWNED.DOCS" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "OWNED_PROP" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.location + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (doctype === "Patrons_System") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.PAT" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "PATRON_DOC" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.completepolicynumber + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.completepolicynumber + " " + state.description + "</Section>\n"
// 	}
// 	if (doctype === "Policy_Decline") {
// 		xmlString = xmlString + "<Report-ID>" + "DECLINE" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "PL_DECLINE" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.insuredname + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.agencyname + "</Section>\n"
// 	}
// 	if (doctype === "RTW_System") {
// 		xmlString = xmlString + "<Report-ID>" + "RTW.DOCS" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "RTW_DOC" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.rtwpolicynumber + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.rtwpolicynumber + " " + state.description + "</Section>\n"
// 	}

// The below params are incomplete

// if (doctype === "Acctg_Journal") {
// 	if (state.journaltype === "BUDJE") {
// 		console.log("xml budje")
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_BUDJE" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (state.journalType === "CCRNG") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_CCRNG" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (state.journalType === "CJ") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_CJ" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (state.journalType === "CR") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_CR" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (state.journalType === "GJ") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_GJ" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (state.journalType === "IJ") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_IJ" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (state.journalType === "LNCR") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_LNCR" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (state.journalType === "LNRRG") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_LNRRG" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (state.journalType === "PAYRL") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_PAYRL" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (state.journalType === "PLJ") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_PLJ" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (state.journalType === "REVJE") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_REVJE" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (state.journalType === "RJ") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_RJ" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (state.journalType === "OPT") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_OPT" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (state.journalType === "NRGJE") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_NRGJE" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (state.journalType === "ACHD") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.JOUR" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "JOUR_ACHD" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.identifier + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// }
// 	if (doctype === "ECA_Security") {
// 		xmlString = xmlString + "<Report-ID>" + "SEC.EMAIL" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "ECA_SECURE" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.employeenumber + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (doctype === "Investments") {
// 		if (state.type === "CUSIP") {
// 			xmlString = xmlString + "<Report-ID>" + "CUSIP" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "INV_SEC" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + "</Item>\n" //company
// 			xmlString = xmlString + "<Section>" + "</Section>\n" //description
// 		}
// 		if (state.type === "Securities_on_Deposit") {
// 			xmlString = xmlString + "<Report-ID>" + "SEC.DEP" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "INV_SEC" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + "</Section>\n"
// 		}
// 		if (state.type === "Trust_Docs") {
// 			xmlString = xmlString + "<Report-ID>" + "TRUST.DOC" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "INV_SEC" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + "</Item>\n" //company
// 			xmlString = xmlString + "<Section>" + "</Section>\n" //description
// 		}

// 	}
// 	if (doctype === "Producer") {
// 		xmlString = xmlString + "<Report-ID>" + "A.EMAIL.P" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "PRODUCERID" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.producercode + "</Item>\n" //producercode
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n" //description
// 	}
// 	if (doctype === "Red_Deal") {
// 		xmlString = xmlString + "<Report-ID>" + "" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + "</Item>\n"
// 		xmlString = xmlString + "<Section>" + "</Section>\n"
// 	}
// 	if (doctype === "AP_Docs") {
// 		xmlString = xmlString + "<Report-ID>" + "EMAIL.AP" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "AP_DOCS" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.checkrange + "</Item>\n"
// 		// check range
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 	}
// 	if (doctype === "ITV_Project") {
// 		if (state.company === "Beacon") {
// 			xmlString = xmlString + "<Report-ID>" + "ITV.PROJ" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "POL_BEACON" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.completepolicynumber + "</Item>\n" //policy number
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n" //description
// 		}
// 		if (state.company === "Patrons_Not_V6_or_V7") {
// 			xmlString = xmlString + "<Report-ID>" + "ITV.PROJ" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "PATRON_DOC" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.completepolicynumber + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.company === "State_Auto") {
// 			xmlString = xmlString + "<Report-ID>" + "ITV.PROJ" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "POLICY_DOC" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.completepolicynumber + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 	}
// 	if (doctype === "Large_Line_Dec") {
// 		xmlString = xmlString + "<Report-ID>" + "DEC.MANUAL" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "POLICY_DOC" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.completepolicynumber + "</Item>\n" //policy nummber
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n" //description
// 	}
// 	if (doctype === "HR_Credit_Card") {
// 		xmlString = xmlString + "<Report-ID>" + "HR.CREDIT" + "</Report-ID>\n"
// 		xmlString = xmlString + "<Topic-ID>" + "HR_ACTIVE" + "</Topic-ID>\n"
// 		xmlString = xmlString + "<Item>" + state.agencynumber + "</Item>\n" //employeeno
// 		xmlString = xmlString + "<Section>" + state.description + "</Section>\n" //description
// 	}
// 	if (doctype === "Agency_Docs") {
// 		if (state.type === "Change_Requests") {
// 			xmlString = xmlString + "<Report-ID>" + "A_CHG REQ" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "AGENCYFILE" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.agencynumber + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "Contract") {
// 			xmlString = xmlString + "<Report-ID>" + "A_CONTRACT" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "AGENCYFILE" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.agencynumber + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "Letters") {
// 			xmlString = xmlString + "<Report-ID>" + "A_LETTERS" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "AGENCYFILE" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.agencynumber + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "Miscellaneous") {
// 			xmlString = xmlString + "<Report-ID>" + "A_MISC" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "AGENCYFILE" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.agencynumber + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "Original_File") {
// 			xmlString = xmlString + "<Report-ID>" + "A_ORIGINAL" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "AGENCYFILE" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.agencynumber + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "Prospect") {
// 			xmlString = xmlString + "<Report-ID>" + "A_PROSPECT" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "AGENCYFILE" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.agencynumber + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "State_Forms") {
// 			xmlString = xmlString + "<Report-ID>" + "A_ST FORMS" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "AGENCYFILE" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.agencynumber + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 	}
// 	if (doctype === "Producer_Docs") {
// 		if (state.type === "Change_Requests") {
// 			xmlString = xmlString + "<Report-ID>" + "AP_CHG REQ" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "PRODUCERID" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.producernumber + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "Letters") {
// 			xmlString = xmlString + "<Report-ID>" + "AP_LETTERS" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "PRODUCERID" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.producernumber + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "Original_File") {
// 			xmlString = xmlString + "<Report-ID>" + "AP_ORIGINA" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "PRODUCERID" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.producernumber + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "Personal_Info") {
// 			xmlString = xmlString + "<Report-ID>" + "AP_PER INF" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "PRODUCERID" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.producernumber + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "State_Forms") {
// 			xmlString = xmlString + "<Report-ID>" + "AP_ST FORM" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "PRODUCERID" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.producernumber + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 	}
// 	if (doctype === "HR") {
// 		if (state.type === "Attendance") {
// 			xmlString = xmlString + "<Report-ID>" + "HR.ATTEND" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "HR" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.ssn + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "Benefits") {
// 			xmlString = xmlString + "<Report-ID>" + "HR.BENEFIT" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "HR" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.ssn + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "Payroll") {
// 			xmlString = xmlString + "<Report-ID>" + "HR.PAYROLL" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "HR" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.ssn + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "Personal") {
// 			xmlString = xmlString + "<Report-ID>" + "HR.PERSONL" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "HR" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.ssn + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "Termination") {
// 			xmlString = xmlString + "<Report-ID>" + "HR.TERM" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "HR" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.ssn + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 		if (state.type === "Welfare_Benefits") {
// 			xmlString = xmlString + "<Report-ID>" + "HR.WELFARE" + "</Report-ID>\n"
// 			xmlString = xmlString + "<Topic-ID>" + "HR" + "</Topic-ID>\n"
// 			xmlString = xmlString + "<Item>" + state.ssn + "</Item>\n"
// 			xmlString = xmlString + "<Section>" + state.description + "</Section>\n"
// 		}
// 	}
// 	xmlString = xmlString + "<ClientDescription>S2MClient for Outlook</ClientDescription>\n<ClientVersion>3.1.48</ClientVersion>\n</S2MParms>\n"
// 	return xmlString
// }

// let xmlString2 = "";

// Define a configuration object to map doctype values to XML elements
const config = {
	Acctg_Journal: {
		reportID: (state) => "EMAIL.JOUR",
		topicID: (state) => {
			const reportIDs = {
				BUDJE: "JOUR_BUDJE",
				CCRNG: "JOUR_CCRNG",
				CJ: "JOUR_CJ",
				CR: "JOUR_CR",
				GJ: "JOUR_GJ",
				IJ: "JOUR_IJ",
				LNCR: "JOUR_LNCR",
				LNRRG: "JOUR_LNRRG",
				PAYRL: "JOUR_PAYRL",
				PLJ: "JOUR_PLJ",
				REVJE: "JOUR_REVJE",
				RJ: "JOUR_RJ",
				OPT: "JOUR_OPT",
				NRGJE: "JOUR_NRGJE",
				ACHD: "JOUR_ACHD",
			};

			// Use the state.journaltype to get the appropriate reportID
			return reportIDs[state.type] || "";
		},
		item: (state) => state.identifier,
		section: (state) => state.description,
	},
	Agency: {
		reportID: (state) => "A.EMAIL.A",
		topicID: (state) => "AGENCYFILE",
		item: (state) => state.agencynumber,
		section: (state) => state.description,
	},
	Beacon_System: {
		reportID: (state) => "LET.BEACON",
		topicID: (state) => "POL_BEACON",
		item: (state) => state.beaconsystempolicynumber,
		section: (state) => state.description,
	},
	Bonds: {
		reportID: (state) => "EMAIL.BOND",
		topicID: (state) => "POLICY_DOC",
		item: (state) => state.bondspolicynumber,
		section: (state) => state.description,
	},
	Claim: {
		reportID: (state) => "EMAIL_C",
		topicID: (state) => "CLAIM_DOC",
		item: (state) => `${state.claimsymbol} ${state.claimnumber} ${state.dateofloss}`,
		section: (state) => `${state.claimsymbol} ${state.claimnumber} ${state.description}`,
	},
	Current_Carrier: {
		reportID: (state) => "", // Empty string
		topicID: (state) => "", // Empty string
		item: (state) => "", // Empty string
		section: (state) => "",
	},
	ECA_Security: {
		reportID: (state) => "SEC.EMAIL",
		topicID: (state) => "ECA_SECURE",
		item: (state) => state.employeenumber,
		section: (state) => state.description,
	},
	Investments: {
		reportID: (state) => {
			if (state.type === "CUSIP") return "CUSIP";
			if (state.type === "Securities_on_Deposit") return "SYMBOL";
			if (state.type === "Trust_Docs") return "FUND";
			return "UNKNOWN"; // Add a default value or handle other cases
		},
		topicID: (state) => "INV_FILE",
		item: (state) => {
			if (state.type === "CUSIP") return state.company;
			if (state.type === "Securities_on_Deposit") return state.company;
			if (state.type === "Trust_Docs") return state.company;
			return "UNKNOWN"; // Add a default value or handle other cases
		},
		section: (state) => {
			if (state.type === "CUSIP") return state.description;
			if (state.type === "Securities_on_Deposit") return state.states;
			if (state.type === "Trust_Docs") return state.description;
			return "UNKNOWN"; // Add a default value or handle other cases
		},
	},
	Owned_Prop: {
		reportID: (state) => "OWNED.DOCS",
		topicID: (state) => "OWNED_PROP",
		item: (state) => state.location,
		section: (state) => state.description,
	},
	Patrons_System: {
		reportID: (state) => "EMAIL.PAT",
		topicID: (state) => "PATRON_DOC",
		item: (state) => state.completepolicynumber,
		section: (state) => state.description,
	},
	Policy: {
		reportID: (state) => "EMAIL_P",
		topicID: (state) => "POLICY_DOC",
		item: (state) => {
			if (state.policysymbol.length === 1)
				return `${state.policysymbol}   ${state.doctypepolicynumber}`;
			if (state.policysymbol.length === 2)
				return `${state.policysymbol}  ${state.doctypepolicynumber}`;
			if (state.policysymbol.length === 3)
				return `${state.policysymbol} ${state.doctypepolicynumber}`;
			// `${state.policysymbol} ${state.policynumber}`
		},
		section: (state) => {
			if (state.policysymbol.length === 1)
				return `${state.policysymbol}   ${state.doctypepolicynumber} ${state.description}`;
			if (state.policysymbol.length === 2)
				return `${state.policysymbol}  ${state.doctypepolicynumber} ${state.description}`;
			if (state.policysymbol.length === 3)
				return `${state.policysymbol} ${state.doctypepolicynumber} ${state.description}`;
		},
	},
	Policy_Decline: {
		reportID: (state) => "DECLINE",
		topicID: (state) => "PL_DECLINE",
		item: (state) => state.insuredname,
		section: (state) => state.agencyname,
	},
	Producer: {
		reportID: (state) => "A.EMAIL.P",
		topicID: (state) => "PRODUCERID",
		item: (state) => state.producercode,
		section: (state) => state.description,
	},
	Red_Deal: {
		reportID: (state) => {
			console.log("INside docxmlstate.compan", state.company)
			if (state.type === "FSM_Companion") return "COMPANION";
			if (state.type === "FSM_Rockhill") return "ROCKHILL";
			if (state.type === "FSM_State National") return "STATE.NAT";
			if (state.type === "RSC_Companion") return "COMPANION";
			if (state.type === "RSC_Plaza") return "PLAZA";
			if (state.type === "RSC_State National") return "STATE.NAT";
			if (state.type === "RSC_Rockhill") return "ROCKHILL";
			if (state.type === "SIG_Plaza") return "PLAZA";
			if (state.type === "Slice_Plaza") return "PLAZA";
			if (state.type === "Slice_Rockhill") return "ROCKHILL";
		}, // Empty string
		topicID: (state) => {
			console.log("INside docxmlstate.compan", state.company)
			if (state.type === "FSM_Companion") return "RED_FSRM";
			if (state.type === "FSM_Rockhill") return "RED_FSRM";
			if (state.type === "FSM_State National") return "RED_FSRM";
			if (state.type === "RSC_Companion") return "RED_RSC";
			if (state.type === "RSC_Plaza") return "RED_RSC";
			if (state.type === "RSC_State National") return "RED_RSC";
			if (state.type === "RSC_Rockhill") return "RED_RSC";
			if (state.type === "SIG_Plaza") return "RED_SIG";
			if (state.type === "Slice_Plaza") return "RED_SLICE";
			if (state.type === "Slice_Rockhill") return "RED_SLICE";
		}, // Empty string
		item: (state) => state.company, // Empty string
		section: (state) => state.description, // Empty string
	},
	RTW_System: {
		reportID: (state) => "RTW.DOCS",
		topicID: (state) => "RTW_DOC",
		item: (state) => state.rtwpolicynumber,
		section: (state) => state.description,
	},
	AP_Docs: {
		reportID: (state) => "EMAIL.AP",
		topicID: (state) => "AP_DOCS",
		item: (state) => state.checkrange,
		section: (state) => state.description,
	},
	ITV_Project: {
		reportID: (state) => {
			console.log("INside docxmlstate.compan", state.company)
			if (state.company === "Beacon") return "ITV.PROJ";
			if (state.company === "Patrons_Not_V6_or_V7") return "ITV.PROJ";
			if (state.company === "State_Auto") return "ITV.PROJ";
			return ""; // Default to an empty string or handle other cases as needed
		},
		topicID: (state) => {
			console.log("INside docxmlstate.compan", state.company)
			if (state.company === "Beacon") return "POL_BEACON";
			if (state.company === "Patrons_Not_V6_or_V7") return "PATRON_DOC";
			if (state.company === "State_Auto") return "POLICY_DOC";
			return ""; // Default to an empty string or handle other cases as needed
		},
		item: (state) => state.completepolicynumber, // policy number
		section: (state) => state.description,
	},
	Large_Line_Dec: {
		reportID: (state) => "DEC.MANUAL",
		topicID: (state) => "POLICY_DOC",
		item: (state) => state.completepolicynumber, // policy number
		section: (state) => state.description,
	},
	HR_Credit_Card: {
		reportID: (state) => "HR.CREDIT",
		topicID: (state) => "HR_ACTIVE",
		item: (state) => state.creditcardemployeenumber, // employeeno
		section: (state) => state.description,
	},
	Agency_Docs: {
		reportID: (state) => {
			if (state.type === "Change_Requests") return "A_CHG REQ";
			if (state.type === "Contract") return "A_CONTRACT";
			if (state.type === "Letters") return "A_LETTERS";
			if (state.type === "Miscellaneous") return "A_MISC";
			if (state.type === "Original_File") return "A_ORIGINAL";
			if (state.type === "Prospect") return "A_PROSPECT";
			if (state.type === "State_Forms") return "A_ST FORMS";
			return ""; // Default to an empty string or handle other cases as needed
		},
		topicID: (state) => "AGENCYFILE",
		item: (state) => state.agencynumber,
		section: (state) => state.description,
	},
	Producer_Docs: {
		reportID: (state) => {
			if (state.type === "Change_Requests") return "AP_CHG REQ";
			if (state.type === "Letters") return "AP_LETTERS";
			if (state.type === "Original_File") return "AP_ORIGINA";
			if (state.type === "Personal_Info") return "AP_PER INF";
			if (state.type === "State_Forms") return "AP_ST FORM";
			return ""; // Default to an empty string or handle other cases as needed
		},
		topicID: (state) => "PRODUCERID",
		item: (state) => state.producernumber,
		section: (state) => state.description,
	},
	HR: {
		reportID: (state) => {
			if (state.type === "Attendance") return "HR.ATTEND";
			if (state.type === "Benefits") return "HR.BENEFIT";
			if (state.type === "Payroll") return "HR.PAYROLL";
			if (state.type === "Personal") return "HR.PERSONL";
			if (state.type === "Termination") return "HR.TERM";
			if (state.type === "Welfare_Benefits") return "HR.WELFARE";
			return ""; // Default to an empty string or handle other cases as needed
		},
		topicID: (state) => "HR",
		item: (state) => state.ssn,
		section: (state) => state.description,
	},
	Current_Carrier: {
		reportID: (state) => "CC.ERR.RPT",
		topicID: (state) => "ERROR_RPTS",
		item: (state) => "CURRENT CARRIER", // policy number
		section: (state) => state.description,
	}

	// Add mappings for other doctype values here
};

export function xlmgenerator(item, doctype, state) {
	console.log("XML generator", item, "\n", doctype, "state", state);

	xmlString = xmlString + "<S2MParms>\n<Contact2Email>" + state.id + "</Contact2Email>\n<IncEmailMsg>Yes</IncEmailMsg>\n";

	if (config[doctype]) {
		console.log("DOCCCCCCCCCCCCCCC", config[doctype])
		// if ((doctype === "HR") || (doctype === "Producer_Docs") || (doctype === "Agency_Docs") || (doctype === "ITV_Project") || (doctype === "ITV_Project") || (doctype === "Investments")) {


		// }
		const { reportID: reportFn, topicID: tfn, item: itemFn, section: sectionFn } = config[doctype];
		console.log("newXMLLLLLLLLLLLLLLLLLLLLLLLLLLLL", reportFn(state))
		console.log("cad")
		xmlString += `<Report-ID>${reportFn(state)}</Report-ID>\n`;
		xmlString += `<Topic-ID>${tfn(state)}</Topic-ID>\n`;
		xmlString += `<Item>${itemFn(state)}</Item>\n`;
		xmlString += `<Section>${sectionFn(state)}</Section>\n`;
		// else {
		// 	const { reportID, topicID, item: itemFn, section: sectionFn } = config[doctype];

		// 	xmlString += `<Report-ID>${reportID}</Report-ID>\n`;
		// 	xmlString += `<Topic-ID>${topicID}</Topic-ID>\n`;
		// 	xmlString += `<Item>${itemFn(state)}</Item>\n`;
		// 	xmlString += `<Section>${sectionFn(state)}</Section>\n`;
		// }
	}
	let changedsub =item.subject.replace('&', "&amp;")

	xmlString += "<EM-To>" + state.id + "</EM-To>" + "\n";
	xmlString += "<EM-From>" + state.id + "</EM-From>" + "\n";
	xmlString += "<EM-CC>" + item.cc + "</EM-CC>" + "\n";
	xmlString += "<EM-Date>" + item.dateTimeCreated + "</EM-Date>" + "\n";
	xmlString += "<EM-Subject>" + changedsub + "</EM-Subject>\n";
	xmlString += "<PDFDestination>Mobius</PDFDestination>\n";
	xmlString += "<ClientDescription>S2MClient for Outlook</ClientDescription>\n<ClientVersion>3.1.48</ClientVersion>\n</S2MParms>\n";

	return xmlString;
}